import React, { useEffect } from "react";
/**
 * @component  InputFormField
 * @description Reusable input field component for form
 * * @param {*props value} getFieldProps
 * @returns input field
 */

function InputFormField(getFieldProps) {
  // helper props used here only; the rest (formik field props, maxLength, disabled, aria-*) go to <input>
  const {
    fieldType,
    fieldName,
    errors,
    touched,
    getFocus,
    modalClose,
    refName,
    ...inputProps
  } = getFieldProps;

  const hasError =
    (touched && errors && touched[fieldName] && errors[fieldName]) ||
    (getFocus !== undefined && getFocus && getFocus[fieldName]);

  useEffect(() => {
    if (hasError) {
      if (modalClose !== undefined) {
        modalClose();
      }
    }
  }, [touched, errors, getFieldProps]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="formRow col-1">
      <div className="formFieldWrap">
        <div className="formFieldWrapInner">
          <input
            type={fieldType}
            id={fieldName}
            {...inputProps}
            ref={refName}
            placeholder="Enter"
            className={hasError ? "fieldError" : ""}
          />
        </div>
      </div>
    </div>
  );
}
InputFormField.propTypes = {};

export default InputFormField;
